import { combineReducers } from 'redux'
import ownersReducer from './ownersReducer'
import ticketReducer from './ticketReducer'
import checkedInReducer from './checkedInReducer'
import uiReducer from './uiReducer'

const ticketsScannerReducer = combineReducers({
  owners: ownersReducer,
  ticket: ticketReducer,
  checkedIn: checkedInReducer,
  ui: uiReducer,
})

export default ticketsScannerReducer
